export default function ActiveMemberBadge() {
  return (
    <div className="flex items-center gap-[3px] px-2 py-1 rounded-[20px] backdrop-blur-[4px] bg-[linear-gradient(51.6deg,#d7185d_12.8%,#24339f_86.3%)]">
      <div className="relative shrink-0 size-2.5">
        <div className="absolute inset-0 rounded-full bg-[#ffea00]/30" />
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 size-[5px] rounded-full bg-[#ffea00]" />
      </div>
      <span className="text-white text-[10px] lg:text-sm font-medium font-jost leading-3 lg:leading-5 whitespace-nowrap">
        Active Member
      </span>
    </div>
  );
}
